































import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import LegendOfDollyModule from '@/store/modules/LegendOfDolly';
import Table from '@/components/Table/Index.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import LegendOfDollyData from '@/data/LegendOfDollyData';
import { ILegendOfDolly } from '@/interface/LegendOfDolly';

@Component({
  components: {
    Table,
  },
})
export default class LegendOfDolly extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  LegendOfDollyInstance = getModule(LegendOfDollyModule, this.$store);

  TableHeadMember = [...LegendOfDollyData.TableHeadMember];

  FilteredTableHeadMember: Array<object> = [...LegendOfDollyData.TableHeadMember];

  data: ILegendOfDolly[] = []

  houseEdge = 0;

  totalTurnover = 0;

  totalWinlose = 0;

  created() {
    this.fetcReportData();
  }

  initial() {
    this.currentTool = 'Today';
  }

  async fetcReportData() {
    let response = [];
    response = await this.LegendOfDollyInstance.FetchDollyReport();
    const resData = response.map((item: ILegendOfDolly) => ({
      ...item,
      dateId: this.$moment(item.dateId).format('DD/MM/YYYY'),
    }));
    this.data = resData;
    for (let i = 0; i < this.data.length; i += 1) {
      this.totalTurnover += this.data[i].totalBetPoints;
      this.totalWinlose += this.data[i].totalGain;
    }
    this.houseEdge = 100 - (this.totalWinlose / this.totalTurnover) * 100;
  }
}
